import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './edm-network-linear-milling/HeroSection';
import { BreadcrumbSection } from './edm-network-linear-milling/BreadcrumbSection';
import { DescriptionSection } from './edm-network-linear-milling/DescriptionSection';
import { ChmerHMSeriesSection } from './edm-network-linear-milling/ChmerHMSeriesSection';
import { DiamondSawSection } from './edm-network-linear-milling/DiamondSawSection';
export function EDMNetworkLinearMillingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2151">
      <SeoBar data-id="element-2152" />
      <Header data-id="element-2153" />
      <main className="flex-grow" data-id="element-2154">
        <div className="w-full bg-gray-50 pb-20 min-h-screen" data-id="element-2155">
          <HeroSection data-id="element-2156" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2157">
            <BreadcrumbSection data-id="element-2158" />
            <DescriptionSection data-id="element-2159" />
            <div className="space-y-16" data-id="element-2160">
              <ChmerHMSeriesSection data-id="element-2161" />
              <DiamondSawSection data-id="element-2162" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-2163" />
    </div>;
}